import React from 'react';
import Tooltip from './Tooltip';
import Icon from './Icon';
import { getCssVar } from '../../utils/cssVar';
import './StatusBadge.css';

const StatusBadge = ({ status, errorMessage = null, errorType = null }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return {
          className: 'status-badge status-pending',
          iconName: 'Clock',
          text: 'En attente',
          iconColor: getCssVar('--status-pending-text')
        };
      case 'authoritasinprogress':
        return {
          className: 'status-badge status-in-progress',
          iconName: 'RefreshCw',
          text: 'Analyse en cours',
          iconColor: getCssVar('--status-in-progress-text')
        };
      case 'authoritascompleted':
        return {
          className: 'status-badge status-processing',
          iconName: 'Settings',
          text: 'Traitement',
          iconColor: getCssVar('--status-processing-text')
        };
      case 'googleadsinprogress':
        return {
          className: 'status-badge status-processing',
          iconName: 'BarChart3',
          text: 'Récupération données',
          iconColor: getCssVar('--status-processing-text')
        };
      case 'computing':
        return {
          className: 'status-badge status-processing',
          iconName: 'Calculator',
          text: 'Calcul en cours',
          iconColor: getCssVar('--status-processing-text')
        };
      case 'completed':
        return {
          className: 'status-badge status-completed',
          iconName: 'CheckCircle',
          text: 'Terminé',
          iconColor: getCssVar('--status-completed-text')
        };
      case 'failed':
        return {
          className: 'status-badge status-failed',
          iconName: 'XCircle',
          text: 'Échec',
          iconColor: getCssVar('--status-failed-text')
        };
      case 'cancelled':
        return {
          className: 'status-badge status-cancelled',
          iconName: 'XCircle',
          text: 'Annulée',
          iconColor: getCssVar('--status-pending-text')
        };
      default:
        return {
          className: 'status-badge status-unknown',
          iconName: 'HelpCircle',
          text: status || 'Inconnu',
          iconColor: getCssVar('--status-pending-text')
        };
    }
  };

  const config = getStatusConfig(status);

  const getStatusDescription = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return "L'étude est en file d'attente";
      case 'authoritasinprogress':
        return 'Récupération des positions SERP en cours';
      case 'authoritascompleted':
        return 'Analyse SERP terminée, traitement des données';
      case 'googleadsinprogress':
        return 'Calcul des volumes de recherche';
      case 'computing':
        return 'Calcul des KPIs et génération du rapport';
      case 'completed':
        return 'Étude terminée avec succès';
      case 'failed':
        return "L'étude a échoué lors de l'exécution";
      case 'cancelled':
        return "L'étude a été annulée par l'utilisateur";
      default:
        return `Statut : ${status}`;
    }
  };

  const getTooltipContent = () => {
    if (status?.toLowerCase() === 'failed' && (errorMessage || errorType)) {
      return (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Étude échouée</div>
          {errorType && <div style={{ marginBottom: '2px' }}>Type : {errorType}</div>}
          {errorMessage && <div>Détails : {errorMessage}</div>}
        </div>
      );
    }
    return getStatusDescription(status);
  };

  return (
    <Tooltip content={getTooltipContent()} position="top">
      <div className={config.className}>
        <Icon name={config.iconName} size={16} color={config.iconColor} />
        <span className="status-text">{config.text}</span>
      </div>
    </Tooltip>
  );
};

export default StatusBadge;